exports.components = {
  "component---src-templates-book-template-js": () => import("./../../../src/templates/BookTemplate.js" /* webpackChunkName: "component---src-templates-book-template-js" */),
  "component---src-templates-case-study-template-js": () => import("./../../../src/templates/CaseStudyTemplate.js" /* webpackChunkName: "component---src-templates-case-study-template-js" */),
  "component---src-templates-home-page-template-js": () => import("./../../../src/templates/HomePageTemplate.js" /* webpackChunkName: "component---src-templates-home-page-template-js" */)
}

